import apiService from '@/store/apiService';
import {
    ProfileDetailsResponse,
    UpdateProfileDetalsRequest,
    UpdateProfileDetalsResponse
} from './ProfileTypes';
import { convertImageToBase64 } from '@auth/services/jwt/utils/jwtUtils';

export const profileEndpoints = {
    getProfileDetails: '/portal/profile/information/',
    getProfileImage: '/portal/profile/user-logo/',
    uploadProfileImage: '/portal/profile/user-logo/',
    updateProfileDetails: '/portal/profile/update/',
}

export const ProfileTagsTypes = [
    'ProfileDetails',
    'ProfileImage',
] as const;

const ProfileApi = apiService
    .enhanceEndpoints({ addTagTypes: ProfileTagsTypes })
    .injectEndpoints({
        endpoints: (build) => ({
            getProfileDetails: build.query<ProfileDetailsResponse, void>({
                query: () => ({
                    url: profileEndpoints.getProfileDetails,
                    method: 'GET'
                }),
                providesTags: ['ProfileDetails'],
            }),
            getProfileImage: build.query<string, void>({
                query: () => ({
                    url: profileEndpoints.getProfileImage,
                    method: 'GET',
                    responseHandler: async (response) => {
                        const blob = await response.blob();
                        const image = await convertImageToBase64(new Response(blob));
                        return image;
                    },
                }),
                providesTags: ['ProfileImage'],
            }),
            uploadProfileImage: build.mutation<void, File>({
                query: (file) => {
                    const formData = new FormData();
                    formData.append('image', file);
                    return {
                        url: profileEndpoints.uploadProfileImage,
                        method: 'PATCH',
                        body: formData
                    };
                },
                invalidatesTags: ['ProfileImage'],
            }),
            updateProfileDetails: build.mutation<UpdateProfileDetalsResponse, UpdateProfileDetalsRequest>({
                query: (data) => {
                    return {
                        url: profileEndpoints.updateProfileDetails,
                        method: 'POST',
                        body: data
                    }
                },
                invalidatesTags: ['ProfileDetails'],
            }),
        })
    });

export default ProfileApi;

export const {
    useGetProfileDetailsQuery,
    useGetProfileImageQuery,
    useUploadProfileImageMutation,
    useUpdateProfileDetailsMutation,
} = ProfileApi;